var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon03Content(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 15.2H10.8c-.4 0-.8.3-.8.8s.3.8.8.8h11.4c.4 0 .8-.3.8-.8s-.3-.8-.7-.8zM22.3 19.4H10.8c-.4 0-.8.3-.8.8s.3.8.8.8h11.4c.4 0 .8-.3.8-.8s-.3-.8-.7-.8zM22.3 23.6H10.8c-.4 0-.8.3-.8.8s.3.8.8.8h11.4c.4 0 .8-.3.8-.8s-.3-.8-.7-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 10.7l-6.5-6.5c-.6-.7-1.4-1-2.3-1H8.1c-1.1 0-2 .9-2 2v22.7c0 1.1.9 2 2 2H25c1.1 0 2-.9 2-2v-15c0-.8-.3-1.6-.9-2.2zm-7.6-5.4l6.5 6.5c.1.1.1.2.2.3h-6.5c-.4 0-.7-.3-.7-.7V4.9c.2.1.3.2.5.4 0-.1 0 0 0 0zM25 28.4H8.1c-.3 0-.5-.2-.5-.5V5.2c0-.3.2-.5.5-.5h8.4v6.2h-5.7c-.4 0-.8.3-.8.8s.3.8.8.8h6c.4.7 1.1 1.2 1.9 1.2h6.7V28c.1.2-.1.4-.4.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon03Content);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_03_Content.a4f52d94.svg";
export { ForwardRef as ReactComponent };